<template>
    <v-checkbox
        :label="label"
        v-model="localValue"
        color="primary"
        hide-details
        @change="$emit('change', $event)"
        :disabled="disabled"
    ></v-checkbox>
</template>
<script>
export default {
props:['value','label', 'disabled'],
name:"BeeCheckbox",
data(){
    return{
    }
},
computed:{
  localValue: {
      get: function() {
            return this.value
      },
      set: function(value) {
            this.$emit('input', value)
      }
  }
},
}
</script>